import { Router } from "@remix-run/router";
import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Report } from "../../pages/report";
import { OperationReport } from "../../pages/report/operation";
import { Settings } from "../../pages/settings";
import { setMenuItems } from "../../ui/layout/slice";
import { Spinner } from "../../ui/molecoles/spinner";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { keycloak } from "../keycloak";
import { useAppDispatch, useAppSelector } from "../redux/hooks";

const adminRouter = createBrowserRouter([
    {
        path: "/report",
        element: <Report />,
    },
    {
        path: "/report/:id",
        element: <OperationReport />,
    },
    {
        path: "/settings",
        element: <Settings />
    }
]);

export function KeycloakRouter() {
    const roles = useAppSelector((state) => state.keycloak.userRoles);

    const dispatch = useAppDispatch();

    const [router, setRouter] = useState<Router | undefined>(undefined);

    useEffect(() => {
        if (
            roles !== undefined &&
            roles.length > 0 &&
            keycloak.token !== undefined
        ) {
            if (keycloak.hasRealmRole("admin")) {
                setRouter(adminRouter);
                dispatch(
                    setMenuItems([
                        { item: MenuItems.REPORT, section: 1 },
                        // { item: MenuItems.SETTINGS, section: 1 },
                    ])
                );
            } else {
                return;
            }
        }
    }, [roles, keycloak.token]);

    if (router === undefined) {
        return (
            <div className="w-full h-[100vh] flex items-center justify-center">
                <Spinner />
            </div>
        );
    }

    return <RouterProvider router={router} />;
}
